import { CreateChartOptions } from '~/types/create.types';

export function createCanvasContext(
  canvasElement: HTMLCanvasElement,
  options: CreateChartOptions
): CanvasRenderingContext2D | null {
  const context = canvasElement.getContext('2d');

  if (context === null) {
    return context;
  }

  const scale = window.devicePixelRatio;
  canvasElement.width = Math.floor(options.width * scale);
  canvasElement.height = Math.floor(options.height * scale);
  context.scale(scale, scale);
  context.font = options.font.mono;

  return context;
}
